/* ============================================================
   KKUMI — Sleeve Guide · Colours (Galaxy & Palette viewer)
   Toggle a colour line, then pick a shade: swaps the preview image,
   the stage tint and the caption. Everything comes from data-* on
   the server-rendered blocks (trusted merchant settings), so values
   are applied with style / textContent only.
   Shade images are warmed ahead of the click so swaps paint instantly.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.kkBound) return;
    root.dataset.kkBound = '1';

    var stage = root.querySelector('[data-gp-stage]');
    var shine = root.querySelector('[data-gp-shine]');
    var tag = root.querySelector('[data-gp-tag]');
    var slots = [].slice.call(root.querySelectorAll('[data-gp-slot]'));
    var panels = [].slice.call(root.querySelectorAll('[data-gp-panel]'));
    var lines = [].slice.call(root.querySelectorAll('[data-gp-line]'));
    var shades = [].slice.call(root.querySelectorAll('[data-gp-shade]'));
    if (!stage || !panels.length) return;

    function pick(shade) {
      var idx = +shade.dataset.gpShade;
      shades.forEach(function (s) { s.setAttribute('aria-pressed', String(s === shade)); });
      slots.forEach(function (s, i) { s.hidden = i !== idx; });
      if (shade.dataset.tint) stage.style.background = shade.dataset.tint;
      tag.textContent = shade.dataset.tag || '';
    }

    function showLine(n) {
      lines.forEach(function (b) { b.setAttribute('aria-selected', String(+b.dataset.gpLine === n)); });
      panels.forEach(function (p) { p.hidden = +p.dataset.gpPanel !== n; });
      var panel = panels[n];
      shine.hidden = panel.dataset.shine !== 'true';
      var first = panel.querySelector('[data-gp-shade]');
      if (first) pick(first);
    }

    lines.forEach(function (b) { b.addEventListener('click', function () { showLine(+b.dataset.gpLine); }); });
    shades.forEach(function (s) { s.addEventListener('click', function () { pick(s); }); });

    // Lazy slot images: nudge the browser to fetch every shade off the critical path.
    var warm = function () {
      slots.forEach(function (s) {
        var img = s.querySelector('img');
        if (img) img.loading = 'eager';
      });
    };
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(warm, { timeout: 2000 });
    else setTimeout(warm, 200);

    showLine(0);
  }

  function boot() { document.querySelectorAll('[data-kk-gp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
